import React from 'react';
import { Link } from 'react-router-dom';
import './FormatsSection.css';

const FormatsSection = () => {
  return (
    <section className="formats-section fade-in">
      <div className="formats-container">
        <h2 className="heading-art-deco formats-title">
          Les formats the recap
        </h2>

        <div className="formats-list">
          {/* Lives */}
          <div className="format-row slide-up">
            <div className="format-content-left">
              <h3 className="format-name">Lives</h3>
              <p className="format-description">
                Les Lives The Recap sont des temps de partage en direct, organisés à l'issue d'événements en France et à l'international, pour décrypter les enseignements observés sur le terrain.
              </p>
              <p className="format-description">
                Ils permettent de prendre rapidement de la hauteur et de mettre en perspective les tendances qui façonnent le retail et le e-commerce.
              </p>
              <div className="format-buttons">
                <a href="https://www.linkedin.com/events/therecaplelivenrfnewyork7415434484470525952/theater/" target="_blank" rel="noopener noreferrer" className="button button-dark format-btn-replay">
                  voir le replay nrf nyc 2026
                </a>
                <a href="https://www.linkedin.com/events/therecapleliveshoptalkluxe7408791973190578176/theater/" target="_blank" rel="noopener noreferrer" className="button button-dark format-btn-replay">
                  voir le replay shoptalk luxe
                </a>
              </div>
            </div>
            <div className="format-image-right">
              <img src="/images/lives-img.jpg" alt="Lives Format" />
            </div>
          </div>

          {/* Dîners */}
          <div className="format-row slide-up">
            <div className="format-image-left">
              <img src="/images/diners-img.jpg" alt="Dîners Format" />
            </div>
            <div className="format-content-right">
              <h3 className="format-name">Dîners</h3>
              <p className="format-description">
                Les Dîners The Recap sont des rendez-vous en petit comité, pensés pour approfondir les analyses issues de grands événements internationaux.
              </p>
              <p className="format-description">
                Ils offrent un cadre propice aux échanges, au croisement des points de vue et au partage de retours d'expérience terrain.
              </p>
              <Link to="/inscription" className="button button-dark format-btn-inscrire">
                S'inscrire
              </Link>
            </div>
          </div>

          {/* Store Tours */}
          <div className="format-row slide-up">
            <div className="format-content-left">
              <h3 className="format-name">Store Tours</h3>
              <p className="format-description">
                Les Store Tours proposent une lecture concrète du retail à travers la visite de points de vente emblématiques partout dans le monde.
              </p>
              <p className="format-description">
                Ils permettent d'observer les concepts, les usages et les expériences en conditions réelles, au plus près du terrain.
              </p>
              <a href="https://www.youtube.com/playlist?list=PLTmOUgKc3x9ZneYf_u6Xh-5owzQxSNvYl" target="_blank" rel="noopener noreferrer" className="button button-dark format-btn-storetours">
                voir tous les store tours
              </a>
            </div>
            <div className="format-images-right">
              <img src="/images/store-tour-phone-1.png" alt="Store Tour 1" />
              <img src="/images/store-tour-phone-2.png" alt="Store Tour 2" />
              <img src="/images/store-tour-phone-3.png" alt="Store Tour 3" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormatsSection;
